export default __webpack_public_path__ + "images/wall_hard_plastic_white_218ce44de536321ca52ba09357e357cb.png";